module.exports = "/packs/014-10ddfab3f9062f0c2da38bedcc99f6dc.jpg";